export default __webpack_public_path__ + "static/media/abstracto2.23255571.jpg";